import NewsletterForm from "@/components/feature/NewsletterForm";

const perks = [
  "每周一次「本周新开事件」清单",
  "重要反转第一时间追加节点提醒",
  "只发内容更新，不发广告",
];

export default function NewsletterSection() {
  return (
    <section id="subscribe" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="w-full overflow-hidden rounded-lg border border-background-200 bg-foreground-950">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-8 md:p-10">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-accent-400">
              <span className="w-6 h-px bg-accent-400" />
              订阅更新
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold leading-snug text-background-50">
              不想错过反转？
              <br />
              让新故事线主动找到你
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              留下邮箱，每当有值得追的新事件，或者旧事件出现关键进展，我们会整理好一并送达。
            </p>
            <ul className="mt-6 space-y-2.5">
              {perks.map((perk) => (
                <li key={perk} className="flex items-center gap-2.5 text-sm text-background-200">
                  <span className="w-5 h-5 shrink-0 flex items-center justify-center rounded-full bg-primary-500 text-background-50 text-xs">
                    <i className="ri-check-line" />
                  </span>
                  {perk}
                </li>
              ))}
            </ul>
          </div>

          <div className="border-t border-foreground-800 p-8 md:p-10 lg:border-l lg:border-t-0">
            <div className="rounded-lg border border-foreground-800 bg-foreground-900 p-5 md:p-6">
              <h3 className="font-heading text-lg font-bold text-background-50">订阅吃瓜时间线</h3>
              <p className="mt-2 text-xs leading-relaxed text-background-400">
                我们只需要一个邮箱，随时可以退订。
              </p>
              <div className="mt-5">
                <NewsletterForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}